import {NAMES} from "@/scripts/components/ab-picture-sets/ab-picture-sets.constants";
import {SupportedAspectRatioInterface} from "@/scripts/components/ab-picture-sets/ab-picture-sets.interfaces";
import {createDomElementHandler} from "@/scripts/utils/dom.utils";
import {debounce} from "@/scripts/utils/debounce.util";

export function defineAbPictureSetsElement() {

  if (customElements.get(NAMES.TAG_NAME)) return;

  class AbPictureSetsElement extends HTMLElement {

    #initialized = false;

    supportedAspectRatio: SupportedAspectRatioInterface[];
    currentAspectRatio: SupportedAspectRatioInterface;

    private get imageElement(): HTMLImageElement {
      return this.querySelector(`.${NAMES.IMAGE_CLASS}`) as HTMLImageElement;
    }

    constructor() {
      super();
    }

    connectedCallback(): void {
      if (this.#initialized) return;
      this.#initialized = true;
      this.setSupportedAspectRatio(this);
      const imageElement = createDomElementHandler('img', NAMES.IMAGE_CLASS );
      this.replaceChildren(imageElement);
      this.updateImage();
      window.addEventListener('resize', this.debounceUpdateImage.bind(this));
    }

    private updateImage() {
      const headerHeight = document.querySelector(".site-header")?.clientHeight ?? 0;
      const currentAspectRatio = window.innerWidth / (window.innerHeight - headerHeight);

      const matchingRatio = this.supportedAspectRatio
        .find((arObj) =>
          arObj.ratio < currentAspectRatio
        );

      if (matchingRatio === this.currentAspectRatio) return;
      this.currentAspectRatio = matchingRatio;

      const srcset = matchingRatio.images
        .map((image) => `${image.src} ${image.breakPointMax}w`)
        .join(', ');

      const sizes = matchingRatio.images
        .map((image) => `(max-width: ${image.breakPointMax}px) ${image.breakPointMax}px`)
        .join(', ');

      this.imageElement.setAttribute('srcset', srcset);
      this.imageElement.setAttribute('sizes', sizes);
      this.imageElement.setAttribute('alt', matchingRatio.imageAlt);
      this.imageElement.setAttribute('src', matchingRatio.images[0].src);
    }

    debounceUpdateImage = debounce(this.updateImage.bind(this), 100);



    private setSupportedAspectRatio(rootSetsElement: Element) {
      const allSets = Array.from(rootSetsElement.querySelectorAll(NAMES.CHILD_SET_TAG_NAME));
      const supportedAspectRatio: SupportedAspectRatioInterface[] = [];
      allSets.forEach((set: Element) => {
        const setAr = Number(set?.getAttribute('data-ar')) ?? null;
        if (!setAr && setAr !== 0) return;
        const setArAlreadyPushed = supportedAspectRatio
          .some((ratio) =>
            ratio.ratio === setAr
          );
        if (setArAlreadyPushed) return;
        const images = Array
          .from(set.querySelectorAll(NAMES.PICTURE_SINGLE_TAG_NAME))
          ?.map((abImage: Element) => {
            const breakPointMax = Number(abImage.getAttribute('data-bp'));
            const src = abImage.getAttribute('data-src');
            return (!breakPointMax || !src?.length) ? null : { src, breakPointMax };
          })
          ?.filter((set: any) => set);
        supportedAspectRatio.push({ ratio: setAr, images, imageAlt: '' });
      });

      this.supportedAspectRatio = supportedAspectRatio
        ?.sort((ratioObjA, ratioObjB) =>
          ratioObjB.ratio - ratioObjA.ratio
        );

    }




  }

  customElements.define(NAMES.TAG_NAME, AbPictureSetsElement);
}


// import { createDomElementHandler, debounce } from "../../shared/utilities";
//
// interface ISupportedAspectRatio {
//   ratio: number,
//   images: {
//     src: string,
//     breakPointMax: number
//   }[],
//   imageAlt: string,
// }
//
// export class HomeHeader {
//
//   supportedAspectRatio: ISupportedAspectRatio[];
//   currentAspectRatio: number;
//
//   headerOffset: number;
//   imageElement: Element = null;
//
//   constructor(selector: string) {
//
//     const imageWrapper = document.querySelector(selector);
//
//     if (!imageWrapper) {
//       return;
//     }
//
//     const rootSetsElement = imageWrapper.querySelector('ab-picture-sets');
//
//     if (!rootSetsElement) {
//       return;
//     }
//
//     this.imageElement = imageWrapper.querySelector('.home__featured-image');
//
//     if (!this.imageElement) {
//       this.imageElement = createDomElementHandler('img', ['home__featured-image']);
//       imageWrapper.appendChild(this.imageElement);
//     }
//
//     this.supportedAspectRatio = this.getSupportedAspectRatio(rootSetsElement);
//     rootSetsElement.remove();
//
//     if (!this.supportedAspectRatio?.length) {
//       return;
//     }
//
//     window.addEventListener('resize', debounce(this.setHeader.bind(this), 50));
//
//     this.setHeader();
//
//   }
//
//   public static check() {
//     if (!document.querySelector('.home')) {
//       return;
//     }
//
//     new HomeHeader('.home__featured-image-wrapper');
//   }
//
//   private getSupportedAspectRatio(rootSetsElement: Element): ISupportedAspectRatio[] {
//     const allSets = Array.from(rootSetsElement.querySelectorAll('ab-picture-set'));
//     const supportedAspectRatio = [] as ISupportedAspectRatio[];
//     allSets.forEach((set: Element) => {
//       const setAr = Number(set?.getAttribute('data-ar')) ?? null;
//       if (!setAr && setAr !== 0) {
//         return;
//       }
//       const setArAlreadyPushed = supportedAspectRatio.some((ratio: ISupportedAspectRatio) => ratio.ratio === setAr);
//       if (setArAlreadyPushed) {
//         return;
//       }
//       const images = Array.from(set.querySelectorAll('ab-picture-single'))
//         ?.map((abImage: Element) => {
//           const breakPointMax = Number(abImage.getAttribute('data-bp'));
//           const src = abImage.getAttribute('data-src');
//           return (!breakPointMax || !src?.length) ? null : { src, breakPointMax };
//         })
//         ?.filter((set: any) => set);
//       supportedAspectRatio.push({ ratio: setAr, images, imageAlt: '' });
//     });
//
//     return supportedAspectRatio
//       ?.sort((ratioObjA: ISupportedAspectRatio, ratioObjB: ISupportedAspectRatio) => ratioObjB.ratio - ratioObjA.ratio);
//   }
//
//   private setHeader() {
//     const headerHeight = document.querySelector(".site-header")?.clientHeight || 0;
//     const currentAspectRatio = window.innerWidth / (window.innerHeight - headerHeight);
//     const matchingRatio = this.supportedAspectRatio.find((arObj: ISupportedAspectRatio) => arObj.ratio < currentAspectRatio);
//     if (matchingRatio.ratio === this.currentAspectRatio) {
//       return;
//     }
//     this.currentAspectRatio = matchingRatio.ratio;
//     const srcset = matchingRatio.images
//       .map((image) => `${image.src} ${image.breakPointMax}w`)
//       .join(', ');
//     const sizes = matchingRatio.images
//       .map((image) => `(max-width: ${image.breakPointMax}px) ${image.breakPointMax}px`)
//       .join(', ');
//     this.imageElement.setAttribute('srcset', srcset);
//     this.imageElement.setAttribute('sizes', sizes);
//     this.imageElement.setAttribute('alt', matchingRatio.imageAlt);
//     this.imageElement.setAttribute('src', matchingRatio.images[0].src);
//   }
//
// }